export default __webpack_public_path__ + "static/media/Diana e Maroccolo.2491d007.jpg";